import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Enterprise Security',
      description: 'SOC 2 Type II Certified'
    },
    {
      icon: 'Lock',
      title: 'Data Encryption',
      description: 'AES-256 End-to-End'
    },
    {
      icon: 'Eye',
      title: 'Audit Trails',
      description: 'Complete Activity Logging'
    },
    {
      icon: 'Users',
      title: 'Role-Based Access',
      description: 'Granular Permissions'
    }
  ];

  const certifications = [
    {
      name: 'SOC 2',
      badge: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=80&h=80&fit=crop&crop=center'
    },
    {
      name: 'ISO 27001',
      badge: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=80&h=80&fit=crop&crop=center'
    },
    {
      name: 'GDPR',
      badge: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=80&h=80&fit=crop&crop=center'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto">
      {/* Security Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="bg-card rounded-lg p-6 border border-border text-center hover-lift"
          >
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <Icon 
                name={feature?.icon} 
                size={24} 
                className="text-primary"
              />
            </div>
            <h3 className="text-sm font-medium text-foreground mb-2">
              {feature?.title}
            </h3>
            <p className="text-xs text-muted-foreground">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
      {/* Certifications */}
      <div className="bg-muted/50 rounded-lg p-6 border border-border">
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-foreground mb-2">
            Trusted by Enterprise Organizations
          </h3>
          <p className="text-sm text-muted-foreground">
            Industry-leading security and compliance certifications
          </p>
        </div>

        <div className="flex items-center justify-center space-x-8">
          {certifications?.map((cert, index) => (
            <div
              key={index}
              className="flex flex-col items-center space-y-2"
            >
              <div className="w-16 h-16 bg-background rounded-lg border border-border flex items-center justify-center">
                <span className="text-xs font-medium text-foreground">
                  {cert?.name}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Security Statement */}
        <div className="mt-6 pt-6 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            Your data is protected with bank-level security. We never store sensitive information in plain text and maintain complete audit trails for all activities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;